import React, { useState } from 'react'
import { apmcData } from './apmcJson'

const ClassificationFormAPMC = () => {

    //---------------------------------------useState-----------------------------------------
    const [formValues, setFormValues] = useState<{ [key: string]: any }>({});
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [isChecked, setIsChecked] = useState(false);


    //---------------------------------------Handle Change and Handle Submit-----------------------------------------
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, files } = e.target;
    setFormValues({ ...formValues, [name]: type === "file" ? files?.[0] : value });
    };

    const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
        alert("Form submitted successfully");
     
    }
    };


    //---------------------------------------Validation Functions-----------------------------------------

    const validate = () => {
    let newErrors: { [key: string]: string } = {};
    apmcData.forEach((d) => {
        const name = d.response[0].fieldName;
        const type = d.response[0].responseType;
        if (!formValues[name]) newErrors[name] = type === "file" ? "File required" : "Field required";
    });
    if (!isChecked) newErrors["checkbox"] = "You must accept the declaration";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
    };



    //---------------------------------------Input Field Functions-----------------------------------------
    const fileFunction = (name: string) => (
    <>
        <input
            type="file" 
            name={name} 
            className="form-control w-75" 
            onChange={handleChange} 
        />
        {/* {errors[name] && <small className="text-danger">{errors[name]}</small>} */}
    </>
    );

    const textFunction = (name: string, placeholder?: string) => (
    <>
        <input 
            type="text" 
            name={name} 
            className="form-control w-75" 
            placeholder={placeholder || name}
            value={formValues[name] || ""} 
            onChange={handleChange} 
        />
        {/* {errors[name] && <small className="text-danger">{errors[name]}</small>} */}
    </>
    );


  //-----------------------------------------------------Return------------------------------------------------

return (
    <div className="page-wrapper">
      <h2 className="m-5">
        બજાર સમિતિના વર્ગીકરણ બાબત  
        (Classification on an APMC - Application)
      </h2>

      <div className="d-flex flex-column text-nightblue align-items-center justify-content-center m-5">
        <div id="table" className="w-100 overflow-hidden border bg-white border-secondary rounded">
          
          {/* Table Header */}
          <div 
            id="head" 
            className="d-flex w-100 rounded-top border-bottom border-secondary" 
            style={{ backgroundColor: "#CCE3FF" }}
          >
            <h4 className="col-1 d-flex justify-content-center align-items-center">S.No.</h4>
            <h4 className="col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary">પ્રશ્ન(Field)</h4>
            <h4 className="col-5 p-2 justify-content-center d-flex align-items-center">જવાબ(Response)</h4>
          </div>

          {/* Table Rows */}
          {apmcData.map((data) => {
            const val = data.response[0].responseType;
            const fieldName = data.response[0].fieldName;
            const responseName = data.response[0].responseName;

            return (
              <div key={data.sNo} className="d-flex border-bottom border-secondary">
                <h4 className="col-1 p-2 d-flex align-items-center justify-content-center">
                  {data.fieldNo}
                </h4>
                <div className="col-6 p-3 border-start border-end border-secondary d-flex align-items-center justify-content-start">
                  <p className="p-2">{data.fieldVal}</p>
                </div>
                <div className="col-5 p-3 d-flex flex-column align-items-center justify-content-center">
                  {val === "file" 
                    ? fileFunction(fieldName) 
                    : val === "text" 
                    ? textFunction(fieldName, responseName)
                    : null}

                  {/* Error message below each input */}
                  {errors[fieldName] && (
                    <small className="text-danger">{errors[fieldName]}</small>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Checkbox Section */}
      <div className="m-5 mb-3 d-flex align-items-start gap-3">
        <input
          type="checkbox"
          className="form-check-input"
          style={{ transform: "scale(1.5)" }}
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
        />
        <h4>
          પ્રમાણપત્ર: ઉપર મુજબના સામેલ તમામ સાધનિક કાગળો, પ્રમાણપત્રો તથા માહિતીની ચકાસણી / ખરાઈ કરેલ છે.  
          ( Declaration: All the above-mentioned supporting documents, certificates, and information have been verified and cross-checked.)
        </h4>
      </div>

      {/* Checkbox error */}
      {errors["checkbox"] && (
        <p className="text-danger mx-5">{errors["checkbox"]}</p>
      )}

      {/* Info & Submit */}
      <p className="mx-5">
        Based on the tentative amount you entered, you fall under this category.
      </p>
      <div className="d-flex justify-content-end m-5 mt-0">
        <button 
            type="submit" 
            className="btn btn-info"
            onClick={handleSubmit}>
            Submit</button>
      </div>
    </div>
);

}

export default ClassificationFormAPMC
